import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Textarea } from "../ui/textarea";

/** Replaces `window.prompt("Reason for rejecting this pair?")` on the Monthly Timekeeping
 * dashboard. */
export const RejectPairDialog = ({ open, onOpenChange, pair, month, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!pair) return null;

  const handleSubmit = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit(reason.trim());
      setReason("");
      onOpenChange(false);
    } catch (e) {
      // Error already surfaced via toast by the parent action helper.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!submitting) { onOpenChange(next); if (!next) setReason(""); } }}>
      <DialogContent className="max-w-md" data-testid="reject-pair-dialog">
        <DialogHeader>
          <DialogTitle>Reject Timecard Pair</DialogTitle>
          <DialogDescription>This marks the proposed BLUE/RED match as rejected so it can be re-paired or linked manually.</DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-2 text-xs bg-gray-50 rounded-lg p-2.5">
          <p className="text-gray-500">Employee</p><p className="text-right font-semibold text-gray-700">{pair.employee_name || "Unknown"}</p>
          <p className="text-gray-500">Month</p><p className="text-right font-semibold text-gray-700">{month}</p>
          <p className="text-gray-500">BLUE source</p><p className="text-right font-semibold text-gray-700">{pair.blue_file_id ? "Linked" : "Missing"}</p>
          <p className="text-gray-500">RED source</p><p className="text-right font-semibold text-gray-700">{pair.red_file_id ? "Linked" : "Missing"}</p>
          <p className="text-gray-500">Current status</p><p className="text-right font-semibold text-gray-700">{pair.status}</p>
        </div>

        <Textarea data-testid="reject-pair-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason for rejecting this pair (required)" rows={3} />

        <DialogFooter>
          <button data-testid="reject-pair-cancel" onClick={() => onOpenChange(false)} disabled={submitting} className="px-4 py-2 rounded-lg border border-gray-300 text-sm font-semibold hover:bg-gray-50">Cancel</button>
          <button data-testid="reject-pair-confirm" disabled={submitting || !reason.trim()} onClick={handleSubmit} className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-50">
            {submitting ? "Rejecting..." : "Reject Pair"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
